// @flow
import React from 'react';

import FloatingActionButton from 'material-ui/FloatingActionButton';
import FontIcon from 'material-ui/FontIcon';

import { grey700 } from 'material-ui/styles/colors';

export default ({ style, onClick }) => (
  <FloatingActionButton
    style={style}
    mini
    backgroundColor="white"
    onClick={onClick}
    className="intro-tour__step-3 rt-tour__step-0"
  >
    <FontIcon className="material-icons" style={{ color: grey700 }}>
      layers
    </FontIcon>
  </FloatingActionButton>
);



// WEBPACK FOOTER //
// ./components/MapLayerDrawer/MapLayerDrawerButton.js